import { Capacitor, registerPlugin } from "@capacitor/core";

export type AudioOutputRoute = {
  routed: boolean;
  device: string;
  audioMode: number;
  completedAtMs: number;
};

type AudioOutputPlugin = {
  routeToSpeaker(): Promise<AudioOutputRoute>;
  releaseRoute(): Promise<void>;
};

const NativeAudioOutput = registerPlugin<AudioOutputPlugin>("AudioOutput");

export async function restoreNativeSpeakerOutput(): Promise<AudioOutputRoute | null> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android" || !Capacitor.isPluginAvailable("AudioOutput")) return null;
  return NativeAudioOutput.routeToSpeaker();
}

export async function releaseNativeSpeakerOutput(): Promise<void> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android" || !Capacitor.isPluginAvailable("AudioOutput")) return;
  await NativeAudioOutput.releaseRoute();
}
